import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_876v2gfzp6: FaireCollectionEntity = {
  token: "pbc_876v2gfzp6",
  type: "collection",
  name: "books",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ff07703d28b0c16c70289474a64068c2461f961eea29c8c4c271837c7f329d3a.jpeg",
  itemCount: 5,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:24.037Z",
    importedBy: "entity-db-import-collections",
  },
};
